import { render, staticRenderFns } from "./AvatarSection.vue?vue&type=template&id=541c6b6a&scoped=true"
import script from "./AvatarSection.vue?vue&type=script&lang=js"
export * from "./AvatarSection.vue?vue&type=script&lang=js"
import style0 from "./AvatarSection.vue?vue&type=style&index=0&id=541c6b6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541c6b6a",
  null
  
)

export default component.exports